import React from "react";
import { SocialData } from "../../data/social";
import "./social-contact.css";
function SocialContact() {
    const data = SocialData;
  return (
    <><div className="social-contact">
      {data.map((item) => {
        return (
          <a href={item.link} target="_blank">
            <div className="social-icon-div">
              <img src={item.icon} className="social-icon" />
            </div>
          </a>
        );
      })}

    </div><p>+977 9840030835</p><p>krishalbasnet2003@gmail.com</p></>
  );
}

export default SocialContact;